var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep5WizSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1147_1292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 65C55.2254 65 70 50.4493 70 32.5C70 14.5507 55.2254 0 37 0C18.7746 0 4 14.5507 4 32.5C4 50.4493 18.7746 65 37 65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 32.5C67 48.7494 53.6119 62 37 62C20.3881 62 7 48.7494 7 32.5C7 16.2506 20.3881 3 37 3C53.6119 3 67 16.2506 67 32.5Z",
    stroke: "url(#paint0_linear_1147_1292)",
    strokeWidth: 6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7481 31.7025C53.1053 31.3452 53.5898 31.1445 54.0951 31.1445C54.6003 31.1445 55.0848 31.3452 55.4421 31.7025C55.7993 32.0597 56 32.5443 56 33.0495C56 38.1017 53.993 42.947 50.4205 46.5195C46.8481 50.092 42.0028 52.099 36.9505 52.099C31.9475 52.0873 27.1528 50.0941 23.6159 46.5556C20.9475 43.9015 19.125 40.5165 18.3785 36.8277C17.632 33.1389 17.9949 29.3116 19.4214 25.8288C20.8479 22.3461 23.2742 19.3639 26.3939 17.2587C29.5136 15.1535 33.187 14.0196 36.9505 14C38.4708 14.0063 39.9854 14.1852 41.4653 14.5334C41.7214 14.5788 41.9656 14.6762 42.1826 14.8195C42.3997 14.9629 42.5851 15.1492 42.7274 15.367C42.8698 15.5847 42.966 15.8294 43.0101 16.0857C43.0543 16.3421 43.0455 16.6048 42.9842 16.8576C42.923 17.1105 42.8106 17.3481 42.654 17.5558C42.4974 17.7636 42.2999 17.937 42.0737 18.0655C41.8475 18.194 41.5974 18.2748 41.3387 18.3029C41.0801 18.331 40.8185 18.3059 40.5699 18.229C39.3823 17.958 38.1686 17.8175 36.9505 17.8099C34.9417 17.8034 32.9517 18.1977 31.0971 18.9697C29.2425 19.7416 27.5605 20.8757 26.1495 22.3056C24.0277 24.44 22.5854 27.155 22.0045 30.108C21.4236 33.0611 21.7301 36.12 22.8853 38.8991C24.0406 41.6782 25.9928 44.053 28.4959 45.7241C30.999 47.3952 33.9409 48.2877 36.9505 48.2891C40.9923 48.2891 44.8686 46.6835 47.7265 43.8255C50.5845 40.9675 52.1901 37.0913 52.1901 33.0495C52.1901 32.5443 52.3908 32.0597 52.7481 31.7025ZM31.2357 31.1367C31.743 31.1367 32.2295 31.3383 32.5883 31.697L36.9506 35.9831L48.7994 22.2675C49.1394 21.9135 49.6029 21.7044 50.0933 21.6838C50.5838 21.6632 51.0632 21.8327 51.4317 22.157C51.8002 22.4813 52.0293 22.9353 52.0712 23.4243C52.1131 23.9134 51.9647 24.3997 51.6568 24.782L38.3221 40.0216C38.1501 40.2177 37.9395 40.3764 37.7036 40.4878C37.4677 40.5992 37.2114 40.661 36.9506 40.6693C36.6999 40.6707 36.4514 40.6227 36.2193 40.5279C35.9872 40.4331 35.7761 40.2934 35.5981 40.1168L29.8832 34.402C29.5245 34.0433 29.323 33.5568 29.323 33.0495C29.323 32.5422 29.5245 32.0557 29.8832 31.697C30.2419 31.3383 30.7284 31.1367 31.2357 31.1367Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1147_1292",
    x: 0,
    y: 0,
    width: 74,
    height: 73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1147_1292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1147_1292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1147_1292",
    x1: 37,
    y1: 0,
    x2: 37,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD4E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0742F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5WizSelected);
export default __webpack_public_path__ + "static/media/step5WizSelected.71efa868768134a3184d5560f5983bf6.svg";
export { ForwardRef as ReactComponent };